import { useState } from 'react';
import FilterIcon from '../../../../assets/icons/new_icon/filter.svg';
import { Checkbox } from '../../../../components';
import { ShipmentStatus } from '../../interfaces';
import './StatusOptionsPopup.scss';

interface Props {
  options: string[];
  selectedStatus: string;
  onChangeOption: (option: ShipmentStatus) => void;
}

export default function StatusOptionsPopup({
  options,
  selectedStatus,
  onChangeOption,
}: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className='StatusOptionsPopup'>
      Status
      <button
        className='IconButton'
        onClick={() => setIsOpen(!isOpen)}
      >
        <img src={FilterIcon} alt='Filter' />
      </button>
      <div
        className='PopupContainer'
        hidden={!isOpen}
      >
        {options.map((option: any) => (
          <Checkbox
            checked={selectedStatus === option}
            onChange={(label: string) => {
              onChangeOption(label as ShipmentStatus);
              setIsOpen(false);
            }}
            label={option ? option : 'All'}
          />
        ))}
      </div>
    </div>
  );
}
